// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setupBox {
  position: relative;
  width: 100%;
}
.setupWrapper {
  position: relative;
  margin-top: 16px;
  margin-right: 12px;
  display: flex;
  float: right;
  z-index: 10;
}
.setupWrapper .setupContainer {
  position: relative;
  font-size: 16px;
  font-weight: 500;
  width: 131px;
  height: 32px;
  padding: 4px 15px;
  cursor: pointer;
  background-color: #F3F4F5;
  border-radius: 8px;
  display: flex;
  margin-right: 2px;
}
.setupWrapper .setupContainer .setupTitle {
  font-size: 14px;
  color: #1b1c1e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.setupWrapper .dropDownIcon {
  height: 32px;
  width: 40px;
  cursor: pointer;
  background-color: #F3F4F5;
  border-radius: 0px 8px 8px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.setupWrapper .dropDownWrapper {
  position: absolute;
  z-index: 12;
  top: 40px;
  left: 0px;
  will-change: transform;
}
.setupWrapper .dropDownWrapper .dropDownContainer {
  overflow-y: auto;
}
.setupWrapper .dropDownWrapper .dropDownContainer .dropDown {
  margin: 0;
  position: relative;
  list-style: none;
}
.setupWrapper .dropDownWrapper .dropDownContainer .dropDown .dropDownItem {
  margin-bottom: 4px;
  background-color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1b1c1e;
  min-height: auto;
  width: calc(8vw + 42px);
  height: 32px;
  overflow: hidden;
  line-height: 1.5;
  padding-top: 6px;
  white-space: nowrap;
  letter-spacing: 0.00938em;
  padding-bottom: 6px;
  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  position: relative;
  box-sizing: border-box;
  text-align: left;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
}
.setupWrapper .dropDownWrapper .dropDownContainer .dropDown .dropDownItem:hover {
  text-decoration: none;
  background-color: rgba(0, 0, 0, 0.04);
}
.setupModal {
  height: 0;
  overflow: unset !important;
}
.setupModal .ant-modal-close-x {
  display: none;
}
.setupModal .ant-modal {
  position: absolute;
  top: 340px;
  transform: translateY(-50%);
  right: 16px;
  transform-origin: unset !important;
}
.setupModal .ant-modal-content {
  border-radius: 8px;
  overflow: hidden;
}
.setupModal .ant-modal-header {
  border-bottom: none;
  padding: 0;
  cursor: move;
  background-color: #F3F4F5;
}
.setupModal .ant-modal-header .ant-modal-title {
  font-weight: 500;
  color: black;
  font-size: 18px;
}
.setupModal .ant-modal-header .ant-modal-title div {
  padding: 20px 24px 6px 24px;
}
.setupModal .ant-modal-body {
  background-color: #F3F4F5;
  padding: 8px 24px 20px 24px;
}
.setupModal .ant-modal-body .ant-input {
  border: none;
  border-radius: 8px;
}
.setupModal .ant-modal-body .buttonGroup {
  margin-top: 20px;
  height: 32px;
}
.setupModal .ant-modal-body .buttonGroup div {
  display: inline-block;
  height: 32px;
  line-height: 32px;
  border-radius: 8px;
  background-color: white;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.setupModal .ant-modal-body .buttonGroup div:nth-of-type(1) {
  float: left;
  width: 102px;
}
.setupModal .ant-modal-body .buttonGroup div:nth-of-type(2) {
  width: 102px;
  float: right;
}
.setupPopover .ant-popover-inner {
  height: 52px;
}
.setupPopover .ant-popover-content {
  top: -28px;
  left: 18px;
}
.acceptPopover .ant-popover-content {
  top: -28px;
  left: 18px;
}
@media (max-width: 1400px) {
  .setupBox .setupWrapper {
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translateX(-50%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/View/Option/Components/Setup/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;AACF;AACA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AACF;AAPA;EASI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;AACJ;AApBA;EAwBM,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AADN;AA3BA;EAiCI,YAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHJ;AArCA;EA4CI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,SAAA;EACA,sBAAA;AAJJ;AA5CA;EAmDM,gBAAA;AAJN;AA/CA;EAsDQ,SAAA;EACA,kBAAA;EACA,gBAAA;AAJR;AApDA;EA2DU,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EAEA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mEAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AALV;AAOU;EACE,qBAAA;EACA,qCAAA;AALZ;AAcA;EAEE,SAAA;EACA,0BAAA;AAbF;AAUA;EAKI,aAAA;AAZJ;AAOA;EAQI,kBAAA;EACA,UAAA;EAEA,2BAAA;EACA,WAAA;EACA,kCAAA;AAbJ;AAAA;EAiBI,kBAAA;EACA,gBAAA;AAdJ;AAJA;EAsBI,mBAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;AAfJ;AAVA;EA4BM,gBAAA;EACA,YAAA;EACA,eAAA;AAfN;AAfA;EAgCQ,2BAAA;AAdR;AAlBA;EAsCI,yBAAA;EACA,2BAAA;AAjBJ;AAtBA;EA0CM,YAAA;EACA,kBAAA;AAjBN;AA1BA;EA+CM,gBAAA;EACA,YAAA;AAlBN;AA9BA;EAmDQ,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAlBR;AAoBQ;EACE,WAAA;EACA,YAAA;AAlBV;AAqBQ;EACE,YAAA;EACA,YAAA;AAnBV;AA6BA;EAEI,YAAA;AA5BJ;AA0BA;EAKI,UAAA;EACA,UAAA;AA5BJ;AAgCA;EAEI,UAAA;EACA,UAAA;AA/BJ;AAmCA;EACE;IAEI,kBAAA;IACA,SAAA;IACA,SAAA;IACA,2BAAA;EAlCJ;AACF","sourcesContent":[".setupBox {\n  position: relative;\n  width: 100%;\n}\n.setupWrapper {\n  position: relative;\n  margin-top: 16px;\n  margin-right: 12px;\n  display: flex;\n  float: right;\n  z-index: 10;\n\n  .setupContainer {\n    position: relative;\n    font-size: 16px;\n    font-weight: 500;\n    width: 131px;\n    height: 32px;\n    padding: 4px 15px;\n    cursor: pointer;\n    background-color: #F3F4F5;\n    border-radius: 8px;\n    display: flex;\n    margin-right: 2px;\n\n\n\n    .setupTitle {\n      font-size: 14px;\n      color: rgb(27, 28, 30);\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n  }\n\n  .dropDownIcon {\n    height: 32px;\n    width: 40px;\n    cursor: pointer;\n    background-color: #F3F4F5;\n    border-radius: 0px 8px 8px 0px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .dropDownWrapper {\n    position: absolute;\n    z-index: 12;\n    top: 40px;\n    left: 0px;\n    will-change: transform;\n\n    .dropDownContainer {\n      overflow-y: auto;\n\n      .dropDown {\n        margin: 0;\n        position: relative;\n        list-style: none;\n\n        .dropDownItem {\n          margin-bottom: 4px;\n          background-color: white;\n          border-radius: 8px;\n          font-size: 14px;\n          font-weight: 500;\n          color: rgb(27, 28, 30);\n          min-height: auto;\n          width: calc(8vw + 42px);\n          height: 32px;\n          overflow: hidden;\n          box-sizing: border-box;\n          line-height: 1.5;\n          padding-top: 6px;\n          white-space: nowrap;\n          letter-spacing: 0.00938em;\n          padding-bottom: 6px;\n          transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n          padding-left: 16px;\n          padding-right: 16px;\n          display: flex;\n          position: relative;\n          box-sizing: border-box;\n          text-align: left;\n          align-items: center;\n          text-decoration: none;\n          cursor: pointer;\n\n          &:hover {\n            text-decoration: none;\n            background-color: rgba(0, 0, 0, 0.04);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n.setupModal {\n  //width: 0;\n  height: 0;\n  overflow: unset !important;\n  .ant-modal-close-x {\n    display: none;\n  }\n  .ant-modal {\n    position: absolute;\n    top: 340px;\n    //left: 50%;\n    transform: translateY(-50%);\n    right: 16px;\n    transform-origin: unset !important;\n  }\n\n  .ant-modal-content {\n    border-radius: 8px;\n    overflow: hidden;\n  }\n\n  .ant-modal-header {\n    border-bottom: none;\n    padding: 0;\n    cursor: move;\n    background-color: #F3F4F5;\n\n    .ant-modal-title {\n      font-weight: 500;\n      color: black;\n      font-size: 18px;\n      div {\n        padding: 20px 24px 6px 24px;\n      }\n    }\n  }\n\n  .ant-modal-body {\n    background-color: #F3F4F5;\n    padding: 8px 24px 20px 24px;\n\n    .ant-input {\n      border: none;\n      border-radius: 8px;\n    }\n\n    .buttonGroup {\n      margin-top: 20px;\n      height: 32px;\n\n      div {\n        display: inline-block;\n        height: 32px;\n        line-height: 32px;\n        border-radius: 8px;\n        background-color: white;\n        text-align: center;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n\n        &:nth-of-type(1) {\n          float: left;\n          width: 102px;\n        }\n\n        &:nth-of-type(2) {\n          width: 102px;\n          float: right;\n        }\n      }\n    }\n  }\n}\n\n\n\n\n.setupPopover {\n  .ant-popover-inner {\n    height: 52px;\n  }\n  .ant-popover-content {\n    top: -28px;\n    left: 18px;\n  }\n}\n\n.acceptPopover {\n  .ant-popover-content {\n    top: -28px;\n    left: 18px;\n  }\n}\n\n@media (max-width: 1400px) {\n  .setupBox {\n    .setupWrapper {\n      position: absolute;\n      top: 50px;\n      left: 50%;\n      transform: translateX(-50%);\n    }\n\n  }\n}\n\n\n\n\n\n\n@primary-color: black;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
